import React, { useCallback } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { AddIcon, HandIcon, ZoomInIcon, ZoomOutIcon } from '../../../components/Icon';
import { BS_TOOLBAR_STATUS } from '../../../comm/constant';
import LayerIcon from '../../../static/images/Layer_1.png';
import BedMode from '../../../static/images/BedMode.png';
import CubicleMode from '../../../static/images/CubicleMode.png';

const useStyles = makeStyles(() => ({
  btn: {
    color: '#fff',
    width: '1.9rem',
    height: '3rem',
  },
  icon: {
    fontSize: '1.8rem',
  },
  layerIcon: {
    fontSize: '1.56rem',
  },
  addIcon: {
    fontSize: '1.25rem',
  },
  cubicleIcon: {
    width: '1.7rem',
    height: '1.65rem',
  },
  bedIcon: {
    width: '1.5rem',
    height: '1.75rem',
  },
}));

const Toolbar = ({ className = '', type = 'landing', status, setStatus, handleCreatePopup }) => {
  const classes = useStyles();
  const { isCubicleV2 } = useSelector((state) => state.bedStatusView);

  const handleSelect = useCallback(() => {
    if (type === 'landing') {
      return;
    }
    setStatus((oldStatus) => ({
      ...oldStatus,
      type: oldStatus.type === BS_TOOLBAR_STATUS.MOVE ? BS_TOOLBAR_STATUS.MOUSE : BS_TOOLBAR_STATUS.MOVE,
    }));
  }, [type]);

  const handleCubicleMode = useCallback(() => {
    setStatus((oldStatus) => ({
      ...oldStatus,
      type: BS_TOOLBAR_STATUS.MOVE,
    }));
  }, []);

  const handleBedMode = useCallback(() => {
    setStatus((oldStatus) => ({
      ...oldStatus,
      type: BS_TOOLBAR_STATUS.MOUSE,
    }));
  }, []);

  const handleZoom = useCallback(
    (type) => () => {
      if (type === 'IN') {
        setStatus((oldStatus) => ({
          ...oldStatus,
          zoom: oldStatus.zoom < 2 ? oldStatus.zoom + 0.1 : oldStatus.zoom,
        }));
      } else {
        setStatus((oldStatus) => ({
          ...oldStatus,
          zoom: oldStatus.zoom > 0.5 ? oldStatus.zoom - 0.1 : oldStatus.zoom,
        }));
      }
    },
    []
  );

  const handleReset = useCallback(() => {
    setStatus((oldStatus) => ({
      ...oldStatus,
      zoom: 1,
      reset: oldStatus.reset + 1,
    }));
  }, []);

  return (
    <Box
      className={className}
      display="flex"
      flexDirection="column"
      alignItems="center"
      bgcolor="#2e4469"
      width="fit-content"
      height="fit-content"
      left="0"
      margin={`12rem auto 0 ${type === 'landing' && isCubicleV2 ? '-1.88rem' : '0'}`}
      zIndex={99}
      borderRadius="6px"
      padding="0 2px"
    >
      {type === 'edit' && (
        <ButtonBase className={classes.btn} onClick={handleCreatePopup(true)}>
          <AddIcon className={classes.addIcon} />
        </ButtonBase>
      )}
      {type === 'landing' ? (
        <ButtonBase className={classes.btn} onClick={handleSelect}>
          <HandIcon className={classes.icon} />
        </ButtonBase>
      ) : (
        <>
          <ButtonBase
            className={classes.btn}
            onClick={handleCubicleMode}
            style={{ backgroundColor: status.type === BS_TOOLBAR_STATUS.MOVE ? 'rgba(255,255,255,0.4)' : 'unset' }}
          >
            <img className={classes.cubicleIcon} src={CubicleMode} alt="CubicleMode" />
          </ButtonBase>
          <ButtonBase
            className={classes.btn}
            onClick={handleBedMode}
            style={{ backgroundColor: status.type === BS_TOOLBAR_STATUS.MOUSE ? 'rgba(255,255,255,0.4)' : 'unset' }}
          >
            <img className={classes.bedIcon} src={BedMode} alt="BedMode" />
          </ButtonBase>
        </>
      )}
      <ButtonBase className={classes.btn} onClick={handleZoom('IN')}>
        <ZoomInIcon className={classes.layerIcon} />
      </ButtonBase>
      <ButtonBase className={classes.btn} onClick={handleZoom('OUT')}>
        <ZoomOutIcon className={classes.layerIcon} />
      </ButtonBase>
      <ButtonBase className={classes.btn} onClick={handleReset} style={{ width: '1.5rem' }}>
        <img className={classes.icon} src={LayerIcon} alt="LayerIcon" style={{ width: '100%' }} />
      </ButtonBase>
    </Box>
  );
};

export default Toolbar;
